module.exports = __webpack_public_path__ + "atomic/organism/o-region-map/icons/cluster.png?v=cdf0ca";


//////////////////
// WEBPACK FOOTER
// ./Sig.Web/src/atomic/organism/o-region-map/icons/cluster.png
// module id = 178
// module chunks = 3